'use strict';

const stripeConfig = require('@mindmup/mindmup-config/src/stripe-plans'),
	freezeConfig = require('@mindmup/mindmup-config/src/freeze-config'),
	ccyorder = ['USD', 'GBP', 'EUR'],
	typeorder = ['personal', 'team', 'domain'],
	plans = Object.keys(stripeConfig.planMetadata).map(planId => {
		const stripePlan = stripeConfig.planMetadata[planId],
			currency = stripeConfig.currencies[stripePlan.currency],
			plan = {
				period: `${stripePlan.period}ly`,
				periodSingle: stripePlan.period,
				id: planId,
				price: parseFloat(stripePlan.price),
				prefix: currency.prefix,
				postfix: currency.postfix,
				CCY: stripePlan.currency,
				type: stripePlan.type,
				sources: currency.sources,
				purchaseAction: stripePlan.purchaseAction
			};

		if (stripePlan.trialPeriodDays) {
			const currencySources = currency.sources.filter(t => t !== 'amazon-pay');
			plan.sources = ['invoice', 'enter-billing-address'].concat(currencySources);
		}
		if (stripePlan.typeLabel) {
			plan.typeLabel = stripePlan.typeLabel;
		}
		if (stripePlan.requireUpgradeAction) {
			plan.requireUpgradeAction = stripePlan.requireUpgradeAction;
		}
		return freezeConfig(plan);
	}).sort((item1, item2) => {
		if (item1.CCY !== item2.CCY) {
			return ccyorder.indexOf(item1.CCY) - ccyorder.indexOf(item2.CCY);
		}
		if (item1.type !== item2.type) {
			return typeorder.indexOf(item1.type) - typeorder.indexOf(item2.type);
		}
		return item1.price - item2.price;
	});


module.exports = (allowedAccountTypes) => {
	if (!allowedAccountTypes) {
		return plans;
	}
	return plans.filter(plan => allowedAccountTypes.includes(plan.type));
};
